import { styled } from 'styled-components';
import { Colors } from '../../../../../play-core/styles/Colors';
import { Fonts } from '../../../../../play-core/styles/Fonts';
import { Shadows } from '../../../../../play-core/styles/Shadows';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { zIndex } from '../../../../../play-core/styles/z-index';
import { TransparentButton } from '../../../components/ClickableComponents/Button';
const timeoutDuration = 300;
export const SortDialog = styled.div.withConfig({
  displayName: "SearchOrderDialogstyles__SortDialog",
  componentId: "sc-rz2u2g-0"
})(["will-change:opacity,bottom;transition:bottom ease-in-out ", "ms;z-index:", ";min-width:300px;right:0;background-color:", ";padding-bottom:8px;", ";", ";", "{left:0;position:fixed;top:auto;transition:bottom ease-in-out ", "ms;bottom:", ";}", "{position:absolute;transition:opacity ease-in-out ", "ms;opacity:", ";}"], timeoutDuration, zIndex.popup, Colors.GREY_3a3a3a, Shadows.applyDouble(8), Fonts.regular(16), Viewports.for('small'), timeoutDuration, ({
  show
}) => show ? 0 : '-300px', Viewports.for('mediumUp'), timeoutDuration, ({
  show
}) => show ? 1 : 0);
export const Header = styled.header.withConfig({
  displayName: "SearchOrderDialogstyles__Header",
  componentId: "sc-rz2u2g-1"
})(["display:flex;align-items:center;justify-content:space-between;color:", ";margin-left:24px;margin-right:24px;height:54px;"], Colors.WHITE);
export const Title = styled.h1.withConfig({
  displayName: "SearchOrderDialogstyles__Title",
  componentId: "sc-rz2u2g-2"
})(["", ";margin-top:0;margin-bottom:0;margin-right:16px;"], Fonts.medium(18));
export const SelectionButton = styled(TransparentButton).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "SearchOrderDialogstyles__SelectionButton",
  componentId: "sc-rz2u2g-3"
})(["border-radius:0;padding-left:24px;padding-right:24px;"]);